import { reducer as contractsReducer } from './slice';

export * as actions from './actions';
export * as selectors from './selectors';

export default contractsReducer;
